import { create, v, w } from '@dojo/framework/core/vdom';
import { icache } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { TextInput } from '@dojo/widgets/text-input';
import { Label } from '@dojo/widgets/label';
import { Button } from '@dojo/widgets/button';
import { IconButton } from './iconButton';
import css from '../css/editor.m.css';
const factory = create({
    icache,
    theme
}).properties();
const items = [
    { value: '_self', label: 'Current Window' },
    { value: '_blank', label: 'New Window' }
];
export const Link = factory(({ middleware: { icache, theme }, properties }) => {
    const { disabled = false, title, onLink } = properties();
    const open = icache.getOrSet('open', false);
    const options = items.map((item) => {
        const { label } = item;
        return v('option', { value: item.value, selected: item.value === icache.get('value') }, [label]);
    });
    const { linkDialog } = theme.classes(css);
    return v('div', { classes: [theme.variant()] }, [
        v('dialog', { classes: [linkDialog], open }, [
            v('div', {}, [
                w(TextInput, {
                    placeholder: 'http(s)://...',
                    value: icache.getOrSet('url', ''),
                    onValue: (value) => {
                        icache.set('url', value);
                    }
                }, [{ label: 'URL: ' }])
            ]),
            v('div', {}, [
                w(Label, {}, ['Target: ']),
                v('select', {
                    disabled,
                    value: icache.getOrSet('target', '_self'),
                    onchange: (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        icache.set('target', event.target.value);
                    }
                }, options)
            ]),
            v('div', {}, [
                w(Button, {
                    onClick: () => {
                        const { url, target } = {
                            url: icache.get('url'),
                            target: icache.get('target')
                        };
                        icache.clear();
                        icache.set('open', false);
                        onLink && onLink(url, target);
                    }
                }, ['Set']),
                w(Button, {
                    onClick: () => {
                        icache.clear();
                        icache.set('open', false);
                    }
                }, ['Cancel'])
            ])
        ]),
        w(IconButton, {
            iconName: 'link',
            disabled,
            title,
            onClick: () => {
                icache.set('open', true);
            }
        })
    ]);
});
